import React, { useRef, useEffect, useCallback } from "react"

export function getChartTextLabel(options) {
  const {
    type = "percent",
    numberOfDecimal = 2,
    unit = "",
    chartType = "pie",
    showSpaceForThousand = true,
  } = options

  var contentBetweenBracket = ""
  var unitToUse = unit
  if (chartType === "pie") {
    switch (type) {
      case "percent":
        contentBetweenBracket = "value.percent"
        unitToUse = "%"
        break
      case "value":
        contentBetweenBracket = "value"
        break
      case "sum":
        contentBetweenBracket = "values.value.sum"
        break
      default:
        contentBetweenBracket = "value"
    }
  } else if (chartType === "stack") {
    switch (type) {
      case "percent":
        contentBetweenBracket = "valueY.totalPercent"
        unitToUse = "%"
        break
      case "value":
        contentBetweenBracket = "valueY"
        break
      default:
        contentBetweenBracket = "valueY"
    }
  }

  var formatNumberString = getFormatNumberText(numberOfDecimal, showSpaceForThousand)

  contentBetweenBracket = contentBetweenBracket + formatNumberString
  var textLabelToReturn = `{${contentBetweenBracket}}`

  //UNIT OR %
  textLabelToReturn += unitToUse
  return textLabelToReturn
}

export function getFormatNumberText(numberOfDecimal, showSpaceForThousand) {
  var formatNumberArgument = getNumberFormat(numberOfDecimal, showSpaceForThousand)
  return `.formatNumber('${formatNumberArgument}')`
}

export function getNumberFormat(numberOfDecimal, showSpaceForThousand) {
  var formatNumberArgument = showSpaceForThousand ? "#,###." : "#."
  if (numberOfDecimal) {
    for (let index = 0; index < numberOfDecimal; index++) {
      formatNumberArgument += "#"
    }
  }

  return formatNumberArgument
}

export const formatNumberDisplayed = (
  content,
  numberOfDecimal = 0,
  showSpaceForThousand = true,
  decimalSeparator = ","
) => {
  if (typeof content !== "number") return content

  var contentText = content.toFixed(numberOfDecimal)
  if (showSpaceForThousand) {
    contentText = contentText.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
  }

  if (decimalSeparator === ",") {
    contentText = contentText.replace(".", decimalSeparator)
  } else if (decimalSeparator === ".") {
    contentText = contentText.replace(",", decimalSeparator)
  }

  return contentText
}

/**
 * Filtre les menu d'export amcharts inutile
 * @param {Array} menuItems
 * @returns la liste des menuItems filtré par ceux que l'on veut garder
 */
export function filterMenuItems(menuItems) {
  if (!Array.isArray(menuItems)) {
    throw new Error("menuItems doit être un array")
  }

  const filteredMenuItems =
    menuItems.filter(item => item.label === "Image" || item.label === "Data") || []

  filteredMenuItems.forEach(item => {
    if (item?.menu) {
      item.menu = item.menu.filter(subItem =>
        ["png", "jpg", "pdf", "csv", "xlsx", "pdfdata"].includes(subItem.type)
      )
    } else {
      throw new Error("La propriété 'menu' n'existe pas sur l'élément")
    }
  })

  return filteredMenuItems
}

export function transformeData(requestLoad, fieldsData, dataChart) {
  if (!Array.isArray(fieldsData) || !Array.isArray(requestLoad)) return dataChart

  const loads = requestLoad?.map(reqLoad => {
    const field = fieldsData?.find(fld => fld.uuid === reqLoad.fieldUUID)
    return {
      ...reqLoad,
      fieldName: field?.name,
    }
  })

  const requestMap = loads?.reduce((acc, curr) => {
    acc[curr.outputUUID] = curr.fieldName
    return acc
  }, {})

  return dataChart?.map(obj => {
    const newObj = {}

    for (let key in obj) {
      if (requestMap[key]) {
        newObj[requestMap[key]] = obj[key]
      } else {
        newObj[key] = obj[key]
      }
    }

    return newObj
  })
}
